const setting = {
    version: "v1",
    versionNunber: 1,
    obj:{
        v:1
    }
}

export default setting
